import MentoringCardWrapper from './MentoringCardWrapper.vue';

export default MentoringCardWrapper;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/cardwrapper/index.ts